<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">Department List</div>
							<!-- Page Header -->
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">You can search department information by department name, status, company, or department manager.</div>
									<div class="tips">· Click the "Edit" button to modify the department name, description, company, or department manager.</div>
									<div class="tips">· If a department is disabled and needs to be reactivated, click the corresponding "Enable" button.</div>
									<div class="tips">· If a department is currently enabled and needs to be suspended, click the corresponding "Disable" button.</div>
								</div>

								<!-- Search -->
								<div class="search_box">
									<div class="search_el">
										<div class="search_el_el mr_r">
											<div class="tit">Department Name</div>
											<el-input v-model="query.departments_name" placeholder="Please enter" clearable></el-input>
										</div>
										<div class="search_el_el mr_l">
											<div class="tit">Department Status</div>
											<el-select v-model="query.status" placeholder="Please select" clearable style="width: 100%;">
												<el-option label="Enabled" :value="1"></el-option>
												<el-option label="Disabled" :value="2"></el-option>
											</el-select>
										</div>
									</div>

									<div class="search_el">
										<!-- <div class="search_el_el mr_r">
											<div class="tit">Company</div>
											<el-select v-model="query.company_id" placeholder="Please select" clearable style="width: 100%;">
												<el-option
													v-for="value in companyList"
													:key="value.id"
													:label="value.company_name"
													:value="value.id"
												></el-option>
											</el-select>
										</div> -->

										<div class="search_el_el">
											<div class="tit">Department Manager</div>
											<el-select v-model="query.departments_userid" filterable placeholder="Please select" clearable style="width: 100%;">
												<el-option
													v-for="value in usersList"
													:key="value.id"
													:label="value.username"
													:value="value.id"
												></el-option>
											</el-select>
										</div>
									</div>

									<div class="btn_box">
										<van-button
											class="btn_el"
											round
											color="linear-gradient(to right, #7BC1FF, #4886FF)"
											@click="search"
										>
											Search
										</van-button>
									</div>
								</div>
								<!-- Search -->

								<!-- Table -->
								<div class="table_box">
									<el-table
										v-loading="tableLoading"
										:data="tableData"
										border
										class="table_el"
										ref="multipleTable"
										header-cell-class-name="table-header"
									>
										<el-table-column prop="id" label="Action" width="80" align="center">
											<template #default="scope">
												<div class="inline_btn">
													<el-button type="primary" size="mini" @click="handleClick('Edit', scope.row)">
														Edit
													</el-button>
												</div>
											</template>
										</el-table-column>

										<el-table-column prop="" label="Status" width="120" align="center" :show-overflow-tooltip="true">
											<template #default="scope">
												<el-tag :type="scope.row.status == 1 ? 'success' : scope.row.status == 2 ? 'danger': ''">
													{{ scope.row.status == 1 ? 'Enabled' : 'Disabled' }}
												</el-tag>
											</template>
										</el-table-column>

										<el-table-column
											prop="departments_name"
											label="Department Name"
											width="200"
											:show-overflow-tooltip="true"
										></el-table-column>

										<!-- <el-table-column prop="" label="Company" width="200" :show-overflow-tooltip="true">
											<template #default="scope">
												{{ scope.row.company_name || '/' }}
											</template>
										</el-table-column> -->

										<el-table-column prop="" label="Description" :show-overflow-tooltip="true">
											<template #default="scope">
												{{ scope.row.description || '/' }}
											</template>
										</el-table-column>

										<el-table-column
											prop="departments_username"
											label="Department Manager"
											width="180"
											:show-overflow-tooltip="true"
										>
											<template #default="scope">
												{{ scope.row.departments_username || '/' }}
											</template>
										</el-table-column>

										<el-table-column prop="id" label="Action" width="120" align="center">
											<template #default="scope">
												<div v-if="scope.row.status == 1" class="inline_btn">
													<el-button type="warning" size="mini" @click="handleClick('Disable', scope.row)">
														Disable
													</el-button>
												</div>

												<div v-if="scope.row.status == 2" class="inline_btn">
													<el-button type="primary" size="mini" @click="handleClick('Enable', scope.row)">
														Enable
													</el-button>
												</div>
											</template>
										</el-table-column>
									</el-table>

									<div class="pagination">
										<el-pagination
											@size-change="handleSizeChange"
											@current-change="handlePageChange"
											:current-page="query.page"
											:page-sizes="[5, 10, 20, 50]"
											:page-size="query.page_size"
											layout="total, sizes, prev, pager, next"
											:total="pageTotal"
										>
										</el-pagination>
									</div>
								</div>
								<!-- Table -->
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>

		<!-- Loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!-- Loading -->
	</div>
</template>

<script>
import { departmentsList, departmentsUpdStatus } from '@/api/system/department';
// import { companyList } from '@/api/system/company';
import { usersList } from '@/api/system/user';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components:{
		headers,
		slider
	},
	data() {
		return {
			isLoading: true,
			query: {
				departments_name: '',
				status: '',
				departments_userid: '',
				// company_id: '',
				page: 1,
				page_size: 10
			},
			tableLoading: true,
			tableData: [],
			pageTotal: 0,  //总条数
			usersList: [],
			// companyList: []
		}
	},
	created(){
		let that = this;
		if(that.$route.query.status) {
			that.query.status = Number(that.$route.query.status);
		}
		//请求用户列表
		usersList({ page: 1, page_size: 9999, status: 1 }).then(res => {
			that.usersList = res.data.data;
		});
		//请求企业列表
		// companyList({ page: 1, page_size: 9999, status: 1, company_name: '', company_userid: '', manage_userid: '' }).then(res => {
		// 	that.companyList = res.data.data;
		// });
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.getTableData();
	},
	watch: {
		//
	},
	methods: {
		//获取表格数据
		getTableData() {
			let that = this;
			that.tableLoading = true;
			departmentsList(that.query).then(res => {
				that.tableLoading = false;
				if(res.code == 200) {
					that.pageTotal = res.data.total;
					that.tableData = res.data.data;
				}else {
					
				}
			});
		},
		//搜索
		search(formName) {
			let that = this;
			that.getTableData();
		},
		//条数选择
		handleSizeChange(value) {
			let that = this;
			that.query.page_size = value;
			that.getTableData();
		},
		//页数跳转
		handlePageChange(value) {
			let that = this;
			that.query.page = value;
			that.getTableData();
		},
		//操作按钮点击
		handleClick(name, value) {
			let that = this;
			switch (name) {
			    case 'Edit':
					that.$router.push({ path: '/system/department/add-edit', query: { oid: value.id } });
				break;
				case 'Disable':
					that.$confirm('Are you sure you want to disable this department?', 'Confirmation', {
						type: 'warning'
					}).then(() => {
						that.$toast.loading({ duration: 0, forbidClick: true });
						departmentsUpdStatus({ id: value.id, status: 2 }).then(res => {
							that.$toast.clear();
							that.$message.success('Operation successful');
							value.status = 2;
						});
					}).catch(() => {
						// that.$message({ type: 'info', message: '您已取消退出登录' });
					});
				break;
				case 'Enable':
					that.$confirm('Are you sure you want to enable this department?', 'Confirmation', {
						type: 'warning'
					}).then(() => {
						that.$toast.loading({ duration: 0, forbidClick: true });
						departmentsUpdStatus({ id: value.id, status: 1 }).then(res => {
							that.$toast.clear();
							that.$message.success('Operation successful');
							value.status = 1;
						});
					}).catch(() => {
						// that.$message({ type: 'info', message: '您已取消退出登录' });
					});
				break;
			}
		},
		//取消
		cancel() {
			this.$router.back();
		},
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_main{
	.page_main{
		padding: 18px 20px;
		//表格
		.table_box{
			width: 100%;
			.inline_btn{
				display: inline-block;
			}
			.pagination {
				margin: 10px 0;
				text-align: right;
			}
		}
		//搜索
		.search_box{
			.search_el{
				display: flex;
				padding-bottom: 10px;
				.search_el_el{
					flex: 1;
				}
				.mr_r{
					margin-right: 10px;
				}
				.mr_l{
					margin-left: 10px;
				}
			}
		}
		.btn_box{
			text-align: right;
			.btn_el{
				margin-left: 10px;
				padding: 12px 24px;
				.van-button__text{
					font-size: 16px;
				}
			}
		}
		.btn_el{
			margin: 10px 0 20px 0;
			border-radius: 6px;
			background-color: #ffb1001a;
			padding: 10px 8px;
			.tips{
				padding: 2px 0;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
	//页头
	.page_header{
		padding: 0 20px;
		height: 60px;
		line-height: 60px;
		background-color: #d8e4f0;
		font-size: 24px;
		font-weight: bold;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
	}
}
</style>
<style scoped>
.main_box{
	height: calc(100vh - 60px);
	overflow-y: auto;
}
.main_box .main_main{
	position: relative;
	min-height: calc(100% - 0px);
	max-height: auto;
	background-color: #FAFAFA;
}
.el-header, .el-main{
	padding: 0;
}
>>> .table_box .inline_btn .el-button{
	padding: 2px 6px;
}
</style>

